import React, { useState, useContext, useEffect } from 'react';
import { Layout, Drawer } from 'antd';
import { useLocation } from 'react-router-dom';
import { useWindowSize } from 'react-use';

import SideDrawer from 'components/SideDrawer';
import { TENANT_TYPE } from 'constants/Common';
import useTenant from 'hooks/data/useTenant';
import { SidebarCollapse } from 'store/actions/ConfigAction';
import { ConfigContext } from 'store/context';

import ClinicSidebarContent from './ClinicSidebarContent';
import SidebarContent from './SidebarContent';
import { TAB_SIZE, WIDTH_MENU } from '../../constants/ThemeSetting';

const { Sider } = Layout;

function Sidebar() {
  const [openDrawer, setOpenDrawer] = useState(undefined);
  const [drawer, setDrawer] = useState('');
  const { pathname } = useLocation();
  const { tenant } = useTenant({ revalidateOnFocus: false });

  const isClinicRoute =
    pathname.startsWith('/demo/v2/calendar') ||
    pathname.startsWith('/demo/v2/clinic-queue') ||
    pathname.startsWith('/demo/v2/clinic-website') ||
    pathname.startsWith('/demo/v2/clinic-roadmap');
  const isClinicTenant = tenant?.type === TENANT_TYPE.CLINIC;
  const SidebarComponent = isClinicRoute || isClinicTenant ? ClinicSidebarContent : SidebarContent;
  const { width } = useWindowSize();
  const {
    ConfigState: { statusCollapse: status, hasSidebar },
    ConfigDispatch,
  } = useContext(ConfigContext);

  useEffect(() => {
    if (openDrawer === false) {
      setDrawer('');
    }
  }, [openDrawer]);

  const toogleSubmenu = drawerName => {
    if (drawerName) {
      const currentDrawer = drawer;

      setDrawer(drawer === drawerName ? '' : drawerName);

      if (currentDrawer === drawerName || !currentDrawer) {
        setOpenDrawer(!openDrawer);
      }
    } else {
      setDrawer('');
      setOpenDrawer(false);
    }
  };

  return (
    <>
      {hasSidebar && (
        <>
          {width > TAB_SIZE ? (
            <Sider trigger={null} width={WIDTH_MENU} theme="lite" collapsible collapsed={status}>
              <SidebarComponent toogleSubmenu={toogleSubmenu} drawer={drawer} openDrawer={openDrawer} />
            </Sider>
          ) : (
            <Drawer
              zIndex={100}
              width={WIDTH_MENU}
              placement="left"
              closable={false}
              className="omi-menu-mobile"
              onClose={() => ConfigDispatch(SidebarCollapse())}
              visible={status}
            >
              <SidebarComponent toogleSubmenu={toogleSubmenu} drawer={drawer} openDrawer={openDrawer} />
            </Drawer>
          )}
          <SideDrawer show={openDrawer} setOpenDrawer={setOpenDrawer} drawer={drawer} collapsed={status} />
        </>
      )}
    </>
  );
}

export default Sidebar;
